// src/context/CloudProviderContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

const CloudProviderContext = createContext();

export const useCloudProvider = () => useContext(CloudProviderContext);

export const CloudProviderProvider = ({ children }) => {
  const { assetId, provider } = useParams();
  const [currentProvider, setCurrentProvider] = useState("");

  useEffect(() => {
    if (provider) {
      setCurrentProvider(provider);
    } else {
      const sessionProvider = sessionStorage.getItem(
        `selectedCloudProvider_${assetId}`
      );
      if (sessionProvider) {
        setCurrentProvider(sessionProvider);
      }
    }
  }, [assetId, provider]);

  const getAnswersForCurrentProvider = () => {
    if (!assetId || !currentProvider) return null;

    const storageKey = `cloudPermitAnswers_${assetId}_${currentProvider}`;
    const savedData = localStorage.getItem(storageKey);
    return savedData ? JSON.parse(savedData) : { overview: [] };
  };

  const saveAnswersForCurrentProvider = (sectionName, answers) => {
    if (!assetId || !currentProvider) return false;

    const storageKey = `cloudPermitAnswers_${assetId}_${currentProvider}`;
    const existingData = localStorage.getItem(storageKey);
    const data = existingData ? JSON.parse(existingData) : {};

    data[sectionName] = answers;
    localStorage.setItem(storageKey, JSON.stringify(data));
    return true;
  };

  return (
    <CloudProviderContext.Provider
      value={{
        currentProvider,
        setCurrentProvider,
        getAnswersForCurrentProvider,
        saveAnswersForCurrentProvider,
        assetId,
      }}
    >
      {children}
    </CloudProviderContext.Provider>
  );
};
